const voucherTypes = Object.freeze({
  NONE: 0,
  TEXT: 1
})

const voucherTypesLabels = Object.freeze({
  0: 'CampaignForm_VoucherType_None',
  1: 'CampaignForm_VoucherType_Text'
})

export { voucherTypesLabels, voucherTypes }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/VoucherTypesEnum.js